var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jade-box",
    {
      staticClass: "flex-1",
      attrs: { title: _vm.$t("paymentMethodsTitle"), hasPadding: "" },
      scopedSlots: _vm._u([
        {
          key: "action",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "flex items-center gap-1" },
                [
                  _c("jade-switch", {
                    attrs: { name: "paymentMethodsSwitch", disabledFocus: "" },
                    on: { onClick: _vm.toogleType },
                  }),
                  _c("jade-text", [_vm._v("Valor em R$")]),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      [
        _c(
          "dash-card-content-fallback",
          { attrs: { hasData: _vm.hasData } },
          _vm._l(_vm.paymentMethods, function (item) {
            return _c(
              "dash-progress-bar",
              {
                key: item.key,
                attrs: {
                  value: item.percentage,
                  color: item.color,
                  currency: item.value,
                  "show-currency": _vm.dataType === _vm.dataTypeEnum.VALUE,
                },
              },
              [
                item.leftIcon
                  ? _c("payment-methods-icons", {
                      attrs: {
                        "icon-name": item.leftIcon.name,
                        "tooltip-list": item.leftIcon.tooltip,
                        "tooltip-id": "paymentMothods_info-tippy-left",
                      },
                    })
                  : _vm._e(),
                _c("jade-text", [_vm._v(_vm._s(_vm.$t(item.name)))]),
                item.rightIcon
                  ? _c("payment-methods-icons", {
                      attrs: {
                        "icon-name": item.rightIcon.name,
                        "tooltip-list": item.rightIcon.tooltip,
                        dataType: _vm.dataType,
                        "tooltip-id": "paymentMothods_info-tippy-right",
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }